export default __webpack_public_path__ + "static/media/enhance-2.c1c8bbf4.png";